(() => {
  if (window.localFireFeatureInteraction) return;
  window.localFireFeatureInteraction = true;

  const initialize = (root) => {
    root.querySelectorAll('.local-fire-feature__media.has-hover').forEach((media) => {
      if (media.querySelector('.local-fire-feature__imageToggle')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'local-fire-feature__imageToggle';
      button.setAttribute('aria-label', 'Afficher l’autre visuel du spectacle');
      button.setAttribute('aria-pressed', 'false');
      let pointerType = '';
      button.addEventListener('pointerdown', (event) => {
        pointerType = event.pointerType;
      });
      button.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !media.classList.contains('is-touch')) return;
        media.classList.remove('is-touch', 'is-secondary');
        button.setAttribute('aria-pressed', 'false');
      });
      button.addEventListener('click', (event) => {
        // Mouse users retain the existing hover interaction; keyboard activation
        // (detail === 0) and touch/pen clicks toggle the persistent visual state.
        const type = event.pointerType || pointerType;
        if (event.detail !== 0 && type === 'mouse') return;
        if (event.detail !== 0) media.classList.add('is-touch');
        const secondary = media.classList.toggle('is-secondary');
        button.setAttribute('aria-pressed', String(secondary));
      });
      media.appendChild(button);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
